import React from 'react';
import {useDispatch} from "react-redux";
import {FormattedMessage} from "react-intl";
import ContestPick from "../../../ContestPick/ContestPick";
import CreateYourOwnParlayFooter from "./CreateYourOwnParlayFooter";
import GlobalConst from "../../../../constants/GlobalConst";
import {setContestPick} from "../../../../stores/pickX/pickX.thunks";
import {clearAllPicks} from "../../../../stores/pickX/pickX.slice";
import './CreateYourOwnParlayRenderer.style.scss';
import {ContestPickType} from "../../../../constants/PickXEnums";
import useDeviceType from "../../../../hooks/useDeviceType";

const CreateYourOwnParlayRenderer = ({parlay, contests}) => {
    const dispatch = useDispatch();
    const totalContests = parlay?.totalContests;
    const nbOfPlaceholders = Math.max(GlobalConst.CUSTOM_PARLAY.MIN_PLAYERS - totalContests, 0);
    const {isMobile} = useDeviceType();

    const handleContestPickClick = (contestId, pick) => {
        dispatch(setContestPick({
            parlayId: parlay.Id,
            contestId: contestId,
            pick
        }));
    };
    const handleClearPicksClick = () => {
        dispatch(clearAllPicks(parlay.Id));
    };

    if(!parlay)
        return null;

    if(isMobile)
        window.scrollTo(0, 0);

    return (
        <div className="CreateYourOwnParlayRenderer">
            {contests.map((contest, index) => (
                <ContestPick
                    key={index}
                    contest={contest}
                    parlay={parlay}
                    onOverClick={() => handleContestPickClick(contest.Id, ContestPickType.Over)}
                    onUnderClick={() => handleContestPickClick(contest.Id, ContestPickType.Under)}
                    showRemoveButton
                />
            ))}
            {Array.from({length: nbOfPlaceholders})
                .map((_, index) => (
                    <div key={index}
                         className="pickRow">
                        <div className="pickNumber">{totalContests + index + 1}</div>
                        <div className="addText">
                            <span className="gold-gradient-text">
                                <FormattedMessage id={"lobbyView.contests.customContest.customParlayTable.add"}/>
                            </span>
                            {index === 0 && <span className="parenthesis">
                                 {!parlay.hasMinContestsRequired &&
                                     <FormattedMessage
                                        id={!parlay.hasAtLeastOneContest ? "lobbyView.contests.customContest.customParlayTable.addParenthesisMin"
                                                                         : "lobbyView.contests.customContest.customParlayTable.addParenthesisMissing"}
                                        values={{
                                         x: nbOfPlaceholders
                                        }}
                                     />}
                            </span>}
                        </div>
                    </div>
                ))}
            {(!parlay.isMaximumContestsReached &&
               parlay.canAddMoreContests) &&
                <div className="pickRow">
                    <div
                        className={"addButton " + (parlay.hasMinContestsRequired ? "minMeet gold-gradient-border" : "")}>+
                    </div>
                    {GlobalConst.FEATURES.CREATE_YOUR_OWN_PARLAY.SHOW_ADD_MORE_PICK_TEXT && <div className="addText gold-gradient-text">
                        <FormattedMessage
                            id={!parlay.hasMinContestsRequired ? "lobbyView.contests.customContest.customParlayTable.emptyStr"
                                                               : "lobbyView.contests.customContest.customParlayTable.addMore"}/>
                    </div>}
                </div>}
            {parlay.hasAtLeastOneContest && <div className="clearButtonContainer">
                                                <button className="clearButton"
                                                        onClick={() => handleClearPicksClick()}>
                                                    <FormattedMessage id={"lobbyView.contests.customContest.customParlayTable.clearPicks"}/>
                                                </button>
                                            </div>}

            {parlay.hasMinContestsRequired && <CreateYourOwnParlayFooter parlay={parlay} contests={contests}/>}
        </div>
    );
}

export default CreateYourOwnParlayRenderer;